module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/font/glyphicons-halflings-regular.woff
// module id = qgxm
// module chunks = 0